/**
 * Descripción legible del ALCANCE de cada permiso de la matriz, para mostrar
 * junto a los checkboxes en cualquier UI que asigne permisos (drawer de
 * permisos por usuario y modal de permisos globales de carpeta).
 *
 * Claves: 'documents.<flag>' y 'folders.<flag>'. Ver spec 2026-06-10 §3.
 */
export const PERMISSION_DESCRIPTIONS = {
  'documents.read':            'Ver y previsualizar archivos; descargar sus adjuntos (XML, vínculos).',
  'documents.create':          'Subir documentos a la carpeta (si la carpeta lo permite).',
  'documents.createXml':       'Adjuntar el XML a un documento.',
  'documents.createLink':      'Adjuntar archivos vinculados a un documento.',
  'documents.createReference': 'Agregar referencias a un documento.',
  'documents.update':          'Aprobar archivos (marcar un archivo como aprobado).',
  'documents.disapprove':      'Quitar la aprobación de un archivo.',
  'documents.delete':          'Eliminar documentos completos (o pedir que se eliminen).',
  'documents.deleteXml':       'Eliminar el XML de un documento (o pedir que se elimine).',
  'documents.deleteReference': 'Quitar referencias de un documento.',
  'documents.deleteLinked':    'Eliminar archivos vinculados a un documento (o pedir que se eliminen).',
  'documents.accounting':      'Subir y reversar la contabilización.',
  'documents.deleteAccounting':'Eliminar (reversar) el archivo de contabilización de un documento.',
  'documents.download':        'Descargar el archivo principal (el documento subido).',
  'folders.read':         'Ver la carpeta y su contenido.',
  'folders.create':       'Crear sub-carpetas.',
  'folders.update':       'Editar el nombre y la descripción de la carpeta.',
  'folders.delete':       'Eliminar la carpeta (requiere token).',
  'folders.download':     'Descargar la carpeta completa como ZIP.',
};

/** Devuelve la descripción de un flag, o cadena vacía si no existe. */
export const describePermission = (group, flag) =>
  PERMISSION_DESCRIPTIONS[`${group}.${flag}`] || '';

export default PERMISSION_DESCRIPTIONS;
